
const url = "/validacertidaolegadas";
const id = "id"

export function pesquisar(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}?${filtro}`).then((res) => {
      resolve(res.data);
    })
  })
}

export function pesquisarAll() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}`).then((res) => {
      resolve(res.data);
    })
  })
}

export function buscarPeloCodigo(codigo) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${codigo}`).then((res) => {
      resolve(res.data);
    })
  })
}

export function remover(codigo) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${codigo}`).then((res) => {
      resolve(res.data);
    })
  })
}

function criar(json) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(json)).then((res) => {
      resolve(res.data);
    })
  })
}

function atualizar(codigo, json) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${codigo}`, JSON.stringify(json)).then((res) => {
      resolve(res.data);
    })
  })
}

export function salvar(data) {
  if (data[id] && data[id] != 0) {
    return atualizar(data[id], data)
  } else {
    return criar(data)
  }
}

export function buscarPessoaPorNomeMatriculaCpf(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.post(`/pessoas/buscagenerica`, JSON.stringify(filtro)).then((res) => {
      resolve(res.data);
    })
  })
}

export function validarBeneficiario(parmJson) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/validarBeneficiario`, JSON.stringify(parmJson)).then((res) => {
      resolve(res.data);
    })
  })
}

export function validarValidarCertidao(parmJson) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/validarCertidao`, JSON.stringify(parmJson)).then((res) => {
      resolve(res.data);
    })
  })
}

export function handleImportarObrigacaoCertidao(codigo, descontoIsIR = false) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/importarObrigacaoCertidao/${codigo}?descontoIsIR=${descontoIsIR}`).then((res) => {
      resolve(res.data);
    })
  })
}

